import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UndoIcon from "@mui/icons-material/Undo";
// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";

// Thunks
import {
  getAllmasterModulesAPI,
  getAllsubmodulesAPI,
  getAllTopicsAPI,
} from "../ppt_activity/Pptactivity.Thunk";
import {
  createPptModule,
  createPptSubModule,
  createPptTopic,
  deletePptModule,
  deletePptSubModule,
  deletePptTopic,
  updatePptModule,
  updatePptSubModule,
  updatePptTopic,
} from "../ppt_modules&subModules/PptModule.Thunk";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  TextField,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
function PptModulesPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  const [usertype, setUsertype] = useState("");
  const [modules, setModules] = useState([]);
  //console.log("modules-----------", modules);
  const [submodules, setSubModules] = useState([]);
  const [topic, setTopic] = useState([]);
  const [selModuleDetails, setSelModuleDetails] = useState("");
  ////console.log("selModuleDetails.moduleid---->", selModuleDetails);
  const [selSubModuleDetails, setSelSubModuleDetails] = useState({});
  const [topics, setTopics] = useState([]);

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];

  // ------------------------------------------

  // -------------------------------------------------

  // -------------- Loader -----------------------
  // ---------------------------------------------

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;

  const [preferedlanguage, setPreferedlanguage] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, skillsetid, skillsetname, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(skillsetid);
    setSelectedSkillsetName(skillsetname);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };

  // --------------------- data --------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/ppt");
  };
  // get all modules all on page load, update and delete
  useEffect(() => {}, []);

  // ------------ Load data & skill ----------------

  // -----------------------------------------------

  // ----------- create, update delete button click ----------

  // on language change
  const preflanguage_select_onchange = (e) => {
    setPreferedlanguage(e.target.value);
  };

  //on usertype change
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
    const body = {
      usertype: event.target.value,
      language: preferedlanguage,
    };
    getAllmasterModulesAPI(body).then((modules) => {
      ////console.log(modules.data, "modules");
      setModules(modules.data);
    });
  };

  //on delete module
  const moduleDelete_clicked = (e) => {
    ////console.log(e, "on delete");
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePptModule(e.moduleid).then((result) => {
          if (result.data.status == "success") {
            const body = {
              usertype: usertype,
              language: preferedlanguage,
            };
            getAllmasterModulesAPI(body).then((modules) => {
              ////console.log(modules.data, "modules");
              setModules(modules.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };
  //on Edit module
  const moduleEdit_clicked = (e) => {
    ////console.log(e, "edited");
    Swal.fire({
      title: "UPDATE SKILLSET",
      input: "text",
      inputValue: e.modulename,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === e.modulename) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          //update function
          const data = {
            // _id: e._id,
            // moduleDetails: {
            // language: preferedlanguage,
            moduleid: e.moduleid,
            modulename: input_value,
            // },
          };
          updatePptModule(data).then((response) => {
            if (response.data.status == "success") {
              const body = {
                usertype: usertype,
                language: preferedlanguage,
              };
              getAllmasterModulesAPI(body).then((modules) => {
                ////console.log(modules.data, "modules");
                setModules(modules.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };
  //on create module

  const [moduleorder, setModuleorder] = useState();

  const submoduleOrder_select_onChange = (event) => {
    setSubmoduleOrder(event.target.value);
  };

  const moduleorder_select_onchange = (event) => {
    setModuleorder(event.target.value);
  };

  const [modulename, setModulename] = useState("");
  const module_create_onChange = (event) => {
    setModulename(event.target.value);
  };
  const handleModuleSave = () => {
    const data = {
      // language: preferedlanguage,
      // moduleid: new Date().getTime(),
      // modulename: modulename,
      usertype: usertype,
      trainingType: "ppt",
      moduleid: new Date().getTime(),
      modulename: modulename,
      moduleOrder: moduleorder,
    };
    // //console.log(modules, "modules-------->");
    // //console.log("data---------->", data);
    // //console.log(
    //   "data2---------->",
    //   modules.map((x) => x.order).filter((y) => y)
    // );
    // //console.log(
    //   modules.map((x) => x.order).filter((y) => y) == data.moduleOrder
    // );

    if (
      moduleorder === undefined ||
      moduleorder === null ||
      moduleorder.length <= 0 ||
      modulename === undefined ||
      modulename === null ||
      modulename.length <= 0
    )
      alert("Check all the fields ");
    else {
      createPptModule(data).then((res) => {
        ////console.log(res, "response");
        if (res.data.status == "success") {
          const body = {
            usertype: usertype,
            language: preferedlanguage,
          };
          getAllmasterModulesAPI(body).then((modules) => {
            setModules(modules.data);
            toast.success("Changes made successfully");
            setModuleorder("");
            setModulename("");
          });
        } else {
          toast.error("Unsuccessful !!");
        }
      });
    }
  };

  // -------------------------------------------------
  //sub modules
  const submoduleEdit_clicked = (e) => {
    ////console.log(e, "edited");
    Swal.fire({
      title: "UPDATE SUBMODULES",
      input: "text",
      inputValue: e.submodulename,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === e.subodulename) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          //update function
          const data = {
            // _id: e._id,
            // submoduleDetails: {
            //   language: preferedlanguage,
            //   moduleid: e.moduleid,
            //   modulename: e.modulename,
            submoduleid: e.submoduleid,
            submodulename: input_value,
            // },
          };
          ////console.log("data sub---->", data);
          updatePptSubModule(data).then((response) => {
            if (response.data.status == "success") {
              const data = {
                usertype: usertype,
                language: preferedlanguage,
                moduleid: e.moduleid,
                // language: preferedlanguage,
              };

              getAllsubmodulesAPI(data).then((submodules) => {
                ////console.log(submodules.data, "modules");
                setSubModules(submodules.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };
  const submoduleDelete_clicked = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePptSubModule(e.submoduleid).then((response) => {
          if (response.data.status == "success") {
            const data = {
              usertype: usertype,
              language: preferedlanguage,
              moduleid: selModuleDetails.moduleid,
              // language: preferedlanguage,
            };
            getAllsubmodulesAPI(data).then((submodules) => {
              // //console.log(submodules.data, "modules");
              setSubModules(submodules.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };
  //on module change
  const module_select_onchange = (e) => {
    ////console.log(e.target.value, "module on change");
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      moduleid: e.target.value.moduleid,
      // language: preferedlanguage,
    };
    ////console.log("data----->", data);
    setSelModuleDetails(e.target.value);
    getAllsubmodulesAPI(data).then((submodules) => {
      // //console.log(submodules.data, "modules");
      setSubModules(submodules.data);
    });
  };
  //on create submodule

  const [submoduleOrder, setSubmoduleOrder] = useState("");

  const [submoduleName, setSubmoduleName] = useState("");
  const submoduleName_select_onChange = (event) => {
    setSubmoduleName(event.target.value);
  };

  const handleSubmoduleSave = () => {
    const data = {
      // language: preferedlanguage,
      // moduleid: selModuleDetails.moduleid,
      // modulename: selModuleDetails.modulename,
      // submoduleid: new Date().getTime(),
      // submodulename: submoduleName,
      usertype: usertype,
      trainingType: "ppt",
      moduleid: selModuleDetails.moduleid,
      submoduleid: new Date().getTime(),
      submodulename: submoduleName,
      submoduleOrder: submoduleOrder,
    };

    if (
      submoduleOrder === undefined ||
      submoduleOrder === null ||
      submoduleOrder.length <= 0 ||
      submoduleName === undefined ||
      submoduleName === null ||
      submoduleName.length <= 0
    )
      alert("check all the fields");
    else {
      createPptSubModule(data).then((response) => {
        if (response.data.status == "success") {
          const data = {
            usertype: usertype,
            language: preferedlanguage,
            moduleid: selModuleDetails.moduleid,
            // language: preferedlanguage,
          };
          getAllsubmodulesAPI(data).then((submodules) => {
            // //console.log(submodules.data, "modules");
            setSubModules(submodules.data);
            toast.success("Changes made successfully");
            setSubmoduleOrder("");
            setSubmoduleName("");
          });
        } else {
          toast.error("Unsuccessful !!");
        }
      });
    }
  };

  //on topic
  const topicEdit_clicked = (e) => {
    // //console.log(e, "edited");
    Swal.fire({
      title: "UPDATE SKILLSET",
      input: "text",
      inputValue: e.topicname,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        if (input_value === e.subodulename) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          //update function
          const data = {
            // _id: e._id,
            // topicDetails: {
            //   language: preferedlanguage,
            //   moduleid: e.moduleid,
            //   modulename: e.modulename,
            //   submoduleid: e.submoduleid,
            //   submodulename: e.submodulename,
            topicid: e.topicid,
            topicname: input_value,
            // },
          };
          updatePptTopic(data).then((response) => {
            if (response.data.status == "success") {
              const data = {
                usertype: usertype,
                language: preferedlanguage,
                moduleid: selModuleDetails.moduleid,

                // usertype: usertype,
                submoduleid: selSubModuleDetails.submoduleid,
              };
              getAllTopicsAPI(data).then((topic) => {
                setTopics(topic.data);
                toast.success("Changes made successfully");
              });
            }
          });
        }
      },
    });
  };
  const topicDelete_clicked = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePptTopic(e.topicid).then((response) => {
          if (response.data.status == "success") {
            const data = {
              usertype: usertype,
              language: preferedlanguage,
              moduleid: selModuleDetails.moduleid,

              // usertype: usertype,
              submoduleid: selSubModuleDetails.submoduleid,
            };
            getAllTopicsAPI(data).then((topic) => {
              setTopics(topic.data);
              toast.success("Changes made successfully");
            });
          }
        });
      }
    });
  };
  //on create topic
  const [topicOrder, setTopicOrder] = useState("");

  const topicOrder_select_onchange = (event) => {
    setTopicOrder(event.target.value);
  };

  const [topicName, setTopicName] = useState("");
  const topicName_select_onchange = (event) => {
    setTopicName(event.target.value);
  };
  const handleTopicSave = () => {
    const data = {
      // language: preferedlanguage,
      // moduleid: selModuleDetails.moduleid,
      // modulename: selModuleDetails.modulename,
      // submoduleid: selSubModuleDetails.submoduleid,
      // submodulename: selSubModuleDetails.submodulename,
      // topicid: new Date().getTime(),
      // topicname: topicName,
      usertype: usertype,
      trainingType: "ppt",
      moduleid: selModuleDetails.moduleid,
      submoduleid: selSubModuleDetails.submoduleid,
      topicid: new Date().getTime(),
      topicname: topicName,
      topicOrder: topicOrder,
    };

    if (
      topicOrder === undefined ||
      topicOrder === null ||
      topicOrder.length <= 0 ||
      topicName === undefined ||
      topicName === null ||
      topicName.length <= 0
    )
      alert("check all the fields");
    else {
      createPptTopic(data).then((response) => {
        if (response.data.status == "success") {
          const data = {
            usertype: usertype,
            language: preferedlanguage,
            moduleid: selModuleDetails.moduleid,

            // usertype: usertype,
            submoduleid: selSubModuleDetails.submoduleid,
          };
          getAllTopicsAPI(data).then((topic) => {
            setTopics(topic.data);
            toast.success("Changes made successfully");
            setTopicOrder("");
            setTopicName("");
          });
        } else {
          toast.error("Unsuccessful !!");
        }
      });
    }
  };

  //on subModule Change
  const submodule_select_onchange = (e) => {
    ////console.log(e.target.value, "");
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      moduleid: selModuleDetails.moduleid,
      submoduleid: e.target.value.submoduleid,
    };
    setSelSubModuleDetails(e.target.value);
    getAllTopicsAPI(data).then((topic) => {
      setTopics(topic.data);
    });
  };
  return (
    <>
      <div>
        <MuiHeader header="PPT Modules/Sub-Modules" />
        <div style={{ marginTop: "80px" }}>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Language</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={preferedlanguage}
              label="Language"
              onChange={preflanguage_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {language_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Usertype</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={usertype} //
              label="Language"
              onChange={usertype_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={navigate_to} //
            variant="outlined"
            sx={{
              m: 1,
              minWidth: 90,
              // backgroundColor: "blue",
              // color: "black",
              marginTop: -8.8,
            }}
            size="small"
          >
            <UndoIcon
              style={{
                color: "orange",
              }}
            ></UndoIcon>
            BACK
          </Button>
        </div>
        <div style={{ display: "flex", marginLeft: "150px" }}>
          <div style={{ padding: "10px" }}>
            <Box
              component="form"
              // sx={{
              //   m: 2,
              //   border: "1px solid grey",
              //   borderRadius: "10px",
              //   width: "430px",
              //   backgroundColor: "lightblue",
              // }}
              // noValidate
              // autoComplete="off"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "16px",
                borderRadius: "10px",
                backgroundColor: "#b5d8f5",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Order"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 100,
                      min: 0,
                    },
                  }}
                  sx={{
                    width: 70,
                    marginTop: 1,
                    marginBottom: 1,
                    marginRight: 1,
                    marginLeft: 1,
                  }}
                  size="small"
                  value={moduleorder}
                  onChange={moduleorder_select_onchange}
                />
                <TextField
                  id="outlined-basic"
                  label="Module"
                  variant="outlined"
                  sx={{
                    width: 120,
                    marginTop: 1,
                    marginBottom: 1,
                    marginRight: 1,
                    marginLeft: 1,
                  }}
                  size="small"
                  value={modulename}
                  onChange={module_create_onChange}
                />

                <Button
                  sx={{
                    width: 70,
                    marginTop: 1,
                    marginBottom: 1,
                    marginRight: 1,
                    marginLeft: 1,
                  }}
                  variant="contained"
                  onClick={handleModuleSave}
                >
                  SAVE
                </Button>
              </div>

              <Box
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#b5d8f5",
                  overflowX: "auto",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    marginTop: "50px",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    {modules.map((element, i) => (
                      <tr key={i}>
                        <td
                          // style={{
                          //   borderCollapse: "collapse",
                          //   width: "20px",
                          //   padding: "5px",
                          //   textAlign: "center",
                          //   verticalAlign: "middle",
                          // }}
                          style={{
                            padding: "8px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {element.moduleOrder}.
                        </td>
                        <td
                          // style={{
                          //   borderCollapse: "collapse",
                          //   wordBreak: "break-all",
                          //   padding: "5px",
                          // }}
                          style={{ padding: "8px", wordBreak: "break-all" }}
                        >
                          {element.modulename}
                        </td>
                        <td
                          // style={{
                          //   borderCollapse: "collapse",
                          //   textAlign: "center",
                          // }}
                          style={{ padding: "9px" }}
                        >
                          <Button onClick={() => moduleEdit_clicked(element)}>
                            <EditIcon style={{ color: "blue" }}></EditIcon>
                          </Button>
                        </td>
                        <td
                          // style={{
                          //   borderCollapse: "collapse",
                          //   padding: "5px",
                          //   textAlign: "center",
                          // }}
                          style={{ padding: "8px" }}
                        >
                          <Button
                            // style={{
                            //   marginLeft: "-15px",
                            //   padding: "5px",
                            //   backgroundColor: "transparent",
                            // }}
                            onClick={() => moduleDelete_clicked(element)}
                          >
                            <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          </div>
          <div style={{ padding: "10px" }}>
            <Box
              component="form"
              sx={{
                display: "flex",
                marginLeft: "20px",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "16px",
                borderRadius: "10px",
                backgroundColor: "#b5d8f5",
              }}
            >
              <FormControl
                sx={{ width: "265px", marginBottom: "16px" }}
                size="small"
              >
                <InputLabel id="demo-select-small">Modules</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={selModuleDetails.moduleid}
                  label="Modules"
                  onChange={module_select_onchange}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {modules.map((element) => (
                    <MenuItem key={element.moduleid} value={element}>
                      {element.modulename}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Order"
                  sx={{ width: "70px", marginRight: "8px" }}
                  size="small"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 100,
                      min: 0,
                    },
                  }}
                  value={submoduleOrder}
                  onChange={submoduleOrder_select_onChange}
                />

                <TextField
                  id="outlined-basic"
                  label="SubModule"
                  sx={{ width: "110px", marginRight: "8px" }}
                  size="small"
                  variant="outlined"
                  value={submoduleName}
                  onChange={submoduleName_select_onChange}
                />

                <Button
                  variant="contained"
                  sx={{ width: "70px", marginRight: "8px" }}
                  onClick={handleSubmoduleSave}
                >
                  SAVE
                </Button>
              </div>

              <Box
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#b5d8f5",
                  overflowX: "auto",
                }}
              >
                <table
                  style={{
                    marginTop: "10px",
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    {submodules.map((element, i) => (
                      <tr key={i}>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {element.submoduleOrder}.
                        </td>
                        <td style={{ padding: "8px", wordBreak: "break-all" }}>
                          {element.submodulename}
                        </td>
                        <td style={{ padding: "9px" }}>
                          <Button
                            onClick={() => submoduleEdit_clicked(element)} //
                          >
                            <EditIcon style={{ color: "blue" }} />
                          </Button>
                        </td>
                        <td style={{ padding: "8px" }}>
                          <Button
                            onClick={() => submoduleDelete_clicked(element)}
                          >
                            <DeleteIcon style={{ color: "red" }} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          </div>
          <div style={{ padding: "10px" }}>
            <Box
              component="form"
              // style={styles.select}
              // noValidate
              // autoComplete="off"
              sx={{
                display: "flex",
                marginLeft: "20px",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "16px",
                borderRadius: "10px",
                // backgroundColor: "#f5f5f5",
                backgroundColor: "#b5d8f5",
              }}
            >
              <div>
                {/* <FormControl
                // style={{ marginLeft: 100 }}
                sx={{ m: 1, width: 140 }}
                size="small"
              > */}
                <FormControl
                  sx={{ width: "265px", marginBottom: "16px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Sub-Modules</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={selSubModuleDetails.submoduleid}
                    label="Age"
                    onChange={submodule_select_onchange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {submodules.map((option) => (
                      <MenuItem key={option.submoduleid} value={option}>
                        {option.submodulename}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              {/* <div style={{ marginLeft: 130, marginTop: -63 }}>
               */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Order"
                  // sx={{
                  //   width: 70,
                  //   marginTop: 2,
                  //   marginBottom: 1,
                  //   marginRight: 1,
                  //   marginLeft: 6,
                  // }}
                  sx={{ width: "70px", marginRight: "8px" }}
                  size="small"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 100,
                      min: 0,
                    },
                  }}
                  value={topicOrder}
                  onChange={topicOrder_select_onchange}
                />

                <TextField
                  // style={{ marginTop: 12 }}
                  // sx={{
                  //   width: 110,
                  //   marginTop: 2,
                  //   marginBottom: 1,
                  //   marginRight: 1,
                  // }}
                  sx={{ width: "110px", marginRight: "8px" }}
                  size="small"
                  id="outlined-basic"
                  label="Topic "
                  variant="outlined"
                  value={topicName}
                  onChange={topicName_select_onchange}
                />

                <Button
                  // style={{ marginTop: -19, marginRight: -82 }}
                  // sx={{
                  //   // width: 70,
                  //   marginTop: 2,
                  //   marginBottom: 1,
                  //   marginRight: 2,
                  // }}
                  sx={{ width: "70px", marginRight: "8px" }}
                  variant="contained"
                  onClick={handleTopicSave}
                >
                  SAVE
                </Button>
              </div>

              <Box
                sx={{
                  borderRadius: "10px",
                  // backgroundColor: "#fff",
                  backgroundColor: "#b5d8f5",
                  // overflowX: "auto",
                }}
              >
                <table
                  style={{
                    // marginTop: 12,
                    // border: "1px solid black",
                    marginTop: "10px",
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    {topics.map((element, i) => (
                      <tr key={i}>
                        <td
                          // style={{
                          //   textAlign: "left",
                          //   // border: "1px solid black",
                          //   borderCollapse: "collapse",
                          // }}
                          style={{
                            padding: "8px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {element.topicOrder}.
                        </td>
                        <td
                          // style={{
                          //   textAlign: "left",
                          //   // border: "1px solid black",
                          //   borderCollapse: "collapse",
                          //   wordBreak: "break-all",
                          // }}
                          style={{ padding: "8px", wordBreak: "break-all" }}
                        >
                          {element.topicname}
                        </td>
                        <td
                          // style={{
                          //   // border: "1px solid black",
                          //   borderCollapse: "collapse",
                          // }}
                          style={{ padding: "10px" }}
                        >
                          <Button
                            // style={{ marginLeft: 25, marginRight: 12 }}
                            // variant="contained"
                            onClick={() => topicEdit_clicked(element)}
                          >
                            <EditIcon style={{ color: "blue" }}></EditIcon>
                          </Button>
                        </td>
                        <td
                          // style={{
                          //   // border: "1px solid black",
                          //   borderCollapse: "collapse",
                          // }}
                          style={{ padding: "8px" }}
                        >
                          <Button
                            // style={{ marginLeft: 25, marginRight: 12 }}
                            // variant="contained"
                            onClick={() => topicDelete_clicked(element)}
                          >
                            <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default PptModulesPage;
const styles = {
  select: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "35px",
    width: "462px",
    // marginRight: "5px",
    backgroundColor: "lightblue",
  },
  selects: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "30px",
    width: "422px",
    // marginRight: "5px",
    backgroundColor: "lightblue",
  },
};
